import { render, staticRenderFns } from "./SelectedDatesTypeServiceForm.vue?vue&type=template&id=64bcd41e"
import script from "./SelectedDatesTypeServiceForm.vue?vue&type=script&lang=js"
export * from "./SelectedDatesTypeServiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports